let App_theme = "";
export default function MainTheme() {
  let dynTheme = JSON.parse(localStorage.getItem("crm_theme"))
    ? JSON.parse(localStorage.getItem("crm_theme"))
    : {};

  return dynTheme;
}
